<template>
  <div class="enterprise-box box-flex-vertical">
    <span class="box-label"><span class="box-must">*</span>企业名称</span>
    <el-input
      v-model="name"
      class="box-item"
      type="text"
      placeholder="请填写您的公司全称"
      size="medium"
      :disabled="state === 0"
      clearable
      maxlength="40"
    />
    <span
      v-show="false"
      class="box-label"
    ><span class="box-must">*</span>企业类型</span>
    <el-select
      v-show="false"
      v-model="type"
      class="box-item"
      placeholder="请选择您的企业类型"
      size="medium"
      :disabled="state === 0"
    >
      <el-option v-for="item in options" :key="item" :value="item" />
    </el-select>
    <div class="box-flex">
      <div class="box-flex-vertical">
        <div class="box-label"><span class="box-must">*</span>营业执照</div>
        <image-selector
          ref="isLicense"
          class="image-select"
          :tip="'营业执照'"
          :clickable="state === 0 ? 0 : 1"
          :url="license"
        />
      </div>
      <div class="box-flex-vertical" style="margin-left: 60px">
        <div class="box-label"><span class="box-must">*</span>授权书</div>
        <image-selector
          ref="isAuthorisation"
          class="image-select"
          :tip="'授权书'"
          :clickable="state === 0 ? 0 : 1"
          :url="authorisation"
        />
      </div>
    </div>
    <div class="box-tip">
      请上传清晰的照片或扫描件，支持png和jpg格式，最大3M
    </div>
    <div class="box-sample">
      <div class="sample-item">
        <img class="sample-img" src="@/assets/imgs/login/sample-normal.png">
        <div>
          <img src="@/assets/imgs/login/sample-yes.png">
          正确示例
        </div>
      </div>
      <div class="sample-item">
        <img class="sample-img" src="@/assets/imgs/login/sample-error-1.png">
        <div>
          <img src="@/assets/imgs/login/sample-no.png">
          边角缺失
        </div>
      </div>
      <div class="sample-item">
        <img class="sample-img" src="@/assets/imgs/login/sample-error-2.png">
        <div>
          <img src="@/assets/imgs/login/sample-no.png">
          照片模糊
        </div>
      </div>
      <div class="sample-item">
        <img class="sample-img" src="@/assets/imgs/login/sample-error-3.png">
        <div>
          <img src="@/assets/imgs/login/sample-no.png">
          闪光强烈
        </div>
      </div>
    </div>
    <div v-show="state !== 0" class="box-btn">
      <div v-show="state === -1" class="btn-left" @click="jump">跳过</div>
      <div v-show="state === -1" class="btn-blank" />
      <div class="btn-right" @click="uploadCheck">提交审核</div>
    </div>
  </div>
</template>

<script>
import ImageSelector from './ImageSelector.vue'
import { uploadImage, submitAgentInfo } from '@/api/member.js'
export default {
  name: 'EnterpriseForm',
  components: { ImageSelector },
  props: {
    // -1未提交0审核中2审核失败
    state: {
      type: Number,
      default: 0
    },
    firm: {
      type: String,
      default: ''
    },
    license: {
      type: String,
      default: ''
    },
    authorisation: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      name: this.firm,
      type: '',
      options: ['工业', '农业', '商业', '其他'],
      licenseFile: null,
      authorisationFile: null,
      licenseParam: '',
      authorisationParam: ''
    }
  },
  methods: {
    jump() {
      this.$router.push('/')
    },
    uploadCheck() {
      if (!this.name) {
        this.$Message.error('请填写名称')
        return
      }

      this.licenseFile = this.$refs.isLicense.getFile()
      if (!this.licenseFile) {
        this.$Message.error('请上传营业执照')
        return
      }
      this.licenseParam = ''
      if (typeof this.licenseFile === 'string') {
        this.licenseParam = this.licenseFile
      }

      this.authorisationFile = this.$refs.isAuthorisation.getFile()
      if (!this.authorisationFile) {
        this.$Message.error('请上传授权书')
        return
      }
      this.authorisationParam = ''
      if (typeof this.authorisationFile === 'string') {
        this.authorisationParam = this.authorisationFile
      }

      this.uploadLicense()
    },
    uploadLicense() {
      if (this.licenseParam) {
        this.uploadAuthorisation()
      } else {
        const formLicense = new FormData()
        formLicense.append('file', this.licenseFile)
        uploadImage(formLicense).then((response) => {
          if (!response.data.url) {
            return this.$Message.error('营业执照上传失败')
          }
          this.licenseParam = response.data.url
          this.uploadAuthorisation()
        })
      }
    },
    uploadAuthorisation() {
      if (this.authorisationParam) {
        this.submit()
      } else {
        const formAuthorisation = new FormData()
        formAuthorisation.append('file', this.authorisationFile)
        uploadImage(formAuthorisation).then((res) => {
          if (!res.data.url) {
            return this.$Message.error('授权书上传失败')
          }
          this.authorisationParam = res.data.url
          this.submit()
        })
      }
    },
    submit() {
      const params = {}
      params.agentName = this.name
      params.authorizationLetter = this.authorisationParam
      params.businessLicense = this.licenseParam
      submitAgentInfo(params).then((resp) => {
        this.$parent.submitCallback()
      })
    }
  }
}
</script>

<style scoped>
.enterprise-box {
  width: 100%;
}
.box-label {
  font-size: 14px;
  color: #2d2d2d;
  margin-top: 18px;
}
.box-must {
  font-size: 14px;
  color: #f6713d;
}
.box-item {
  margin-top: 10px;
}
/deep/ .el-input__inner:focus {
  border-color: #f6713d;
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #f6713d;
}
.box-flex {
  display: flex;
}
.box-flex-vertical {
  display: flex;
  flex-direction: column;
}
.image-select {
  margin-top: 4px;
}
.box-tip {
  color: #999999;
  font-size: 12px;
  margin: 18px 0;
}
.box-sample {
  display: flex;
  justify-content: space-evenly;
}
.sample-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sample-img {
  width: 105px;
  height: 77px;
  object-fit: fill;
}
.sample-item div {
  color: #3d3d3d;
  font-size: 11px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sample-item div img {
  margin: 0 5px 1px 0;
}
.box-btn {
  display: flex;
  margin-top: 18px;
}
.btn-left {
  cursor: pointer;
  flex: 1;
  height: 42px;
  border-radius: 4px;
  border: 1px solid #f6713d;
  line-height: 42px;
  text-align: center;
  color: #f6713d;
  font-size: 14px;
}
.btn-blank {
  width: 18px;
  height: 18px;
}
.btn-right {
  cursor: pointer;
  flex: 1;
  height: 42px;
  border-radius: 4px;
  background: #f6713d;
  line-height: 42px;
  text-align: center;
  color: white;
  font-size: 14px;
}
</style>
